import { IconButton, IconName, Stack } from '@optimus-web/core';
import { WithCancellationPolicyId } from '../types';
import { useUpdateCancellationPolicyDialogForm } from './useUpdateCancellationPolicyDialogForm';
import { useDeleteCancellationPolicyDialog } from './useDeleteCancellationPolicyDialog';

interface CancellationPolicyActionsProps extends WithCancellationPolicyId {
    isEditable?: boolean;
    onSidePanelClose: () => void;
}

export const CancellationPolicyActions = ({
    cancellationPolicyId,
    isEditable = true,
    onSidePanelClose,
}: CancellationPolicyActionsProps) => {
    const { confirmationDialog, openConfirmationDialog } = useDeleteCancellationPolicyDialog({
        cancellationPolicyId,
        onSuccess: onSidePanelClose,
    });
    const [renderDialog, updateAction] = useUpdateCancellationPolicyDialogForm({ cancellationPolicyId });
    return (
        <>
            {isEditable ? (
                <Stack spacing="100">
                    <IconButton
                        variant="tertiary"
                        size="small"
                        onClick={updateAction}
                        icon={IconName.Edit}
                        type="submit"
                    />
                    <IconButton icon={IconName.Delete} size="small" onClick={openConfirmationDialog} type="submit" />
                </Stack>
            ) : null}
            {confirmationDialog}
            {renderDialog()}
        </>
    );
};
